import React, { useState } from "react";
import ModalUpdateCustomer from "../modal/ModalUpdateCustomer";
import { Button } from "antd";
import { useModalLockScroll } from "../../../../hooks/useModalLockScroll";

interface ButtonUpdateCustomerProps {
  id: string;
  update: () => void;
}

const ButtonUpdateCustomer: React.FC<ButtonUpdateCustomerProps> = (
  props: ButtonUpdateCustomerProps
) => {
  const { id, update } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);
    useModalLockScroll(isModalOpen);
  return (
    <div>
      <Button
        type="primary"
        onClick={showModal}
        icon={<i className="fa-solid fa-pen"></i>}
      >
        Cập nhật
      </Button>

      <ModalUpdateCustomer
        id={id}
        onClose={handleCancel}
        visible={isModalOpen}
        update={update}
      />
    </div>
  );
};

export default ButtonUpdateCustomer;
